module.exports = __webpack_public_path__ + "static/media/3.6059e698.svg";